import formatterService from './format.service'
import { parseDate } from './helper-functions'

// Vue 3 filters - converted to global properties
// These will be registered in main.js

export const filters = {
  /* Delegates so `$parseDate` in templates and the direct `parseDate` import in
     ESignedDocuments.vue can't drift apart - they were duplicate copies. */
  parseDate,

  number (value, ...args) {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return value
    }
    return formatterService.formatNumber(value)
  },

  units_number (value, ...args) {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return value
    }
    return formatterService.formatUnitsNumber(value)
  },

  decimals (value, fragtions = 2) {
    if (value === null || value === undefined || Number.isNaN(value) || !value) {
      return value
    }
    return formatterService.formatSeparator(Number(value), fragtions)
  },

  money (value, ...args) {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return value
    }
    return formatterService.formatMoney(value)
  },

  thousands (value, ...args) {
    if (value === null || value === undefined || !value || value === '-') {
      return value
    }
    if (Number.isNaN(value)) {
      return value
    }
    return `${formatterService.formatSeparator(parseInt(value / 1000, 10), 0)} k`
  },

  https (value, ...args) {
    if (value === null || value === undefined || !value) {
      return value
    }
    if (value.indexOf('https://') === 0) {
      return value
    }
    return `${'https://'}${value}`
  }
}
